<template>
<v-card class="grey lighten-4 pb-3" >
  <v-card-title class='subtitle-1 overline' >
    <v-btn icon small class="ml-2"
      @click="get" :loading="requests.get.loading" >
      <v-icon small class="mr-2" >mdi-refresh</v-icon></v-btn>
      Your Team
    <v-spacer/>
    <v-btn outlined to="/settings/team" color="primary" >Billing</v-btn>
  </v-card-title>

  <v-card class="ma-2" outlined >
    <v-card-title class="overline py-1 grey lighten-2" >Account owner</v-card-title>
    <v-list v-if="accountOwnerUser" >
      <v-list-item :to="`/settings/team/${businessId}/${accountOwnerUser.id}`" >
        <v-list-item-avatar color="teal" >
            <v-img
              v-if="accountOwner && accountOwner.profile_picture"
              :src="accountOwner.profile_picture" />
            <!-- <v-avatar color="teal" class="white--text" > -->
            <span v-else class="pl-2 white--text">
              <template v-if="accountOwnerUser.first_name && accountOwnerUser.first_name.length > 0" >{{ accountOwnerUser.first_name[0] }}</template>
              <template v-if="accountOwnerUser.first_name && accountOwnerUser.last_name.length > 0" >{{ accountOwnerUser.last_name[0] }}</template>
            </span>
            <!-- </v-avatar> -->
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{accountOwnerUser.first_name}} {{accountOwnerUser.last_name}}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action ><v-icon >mdi-chevron-right</v-icon></v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>

  <v-card v-if="activeSeats && activeSeats.length > 0" class="ma-2" outlined >
    <v-card-title class="overline py-1 grey lighten-2" >Account members</v-card-title>
    <v-list class="pa-0">
      <template v-for="seat in activeSeats" >
        <v-list-item
          v-if="seat.practitioner && seat.practitioner.user"
          :to="`/settings/team/${businessId}/${seat.practitioner.user.id}`"
          :key="seat.id" >
          <v-list-item-avatar color="teal" >
              <v-img
                v-if="seat.practitioner.profile_picture"
                :src="seat.practitioner.profile_picture" />
              <span v-else class="pl-2 white--text">
                <template v-if="seat.practitioner.user.first_name && seat.practitioner.user.first_name.length > 0" >{{ seat.practitioner.user.first_name[0] }}</template>
                <template v-if="seat.practitioner.user.last_name && seat.practitioner.user.last_name.length > 0" >{{ seat.practitioner.user.last_name[0] }}</template>
              </span>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{seat.practitioner.user.first_name}} {{seat.practitioner.user.last_name}}
            </v-list-item-title>
            <!-- <v-list-item-subtitle >
              <v-chip x-small outlined v-for="mem in seat.memberships" :key="mem.id" class="mr-1" >
                {{mem.role}} @ {{mem.service_data.title}}</v-chip>
            </v-list-item-subtitle> -->
          </v-list-item-content>
          <v-list-item-action ><v-icon >mdi-chevron-right</v-icon></v-list-item-action>
        </v-list-item>
        <template >
          <v-chip x-small outlined v-for="mem in seat.memberships" :key="mem.id" class="mr-1" >
            {{mem.role}} @ {{mem.service_data.title}}</v-chip>
        </template>
        <v-divider :key="`div-${seat.id}`" class="mt-2" />
      </template>
    </v-list>
  </v-card>

  <template >
    <v-list v-for="space in spaces.Owner" :key="space.id" outlined rounded class="mx-3 mb-3" >

      <v-subheader >
        <router-link
          :to="`/settings/team/spaces/${space.id}`" class="overline" >
          {{space.title}}
        </router-link>

        <v-spacer/>
        <v-chip x-small label outlined class="float-right" >#{{space.id}}</v-chip>
      </v-subheader>

      <v-list-item-group v-model="selectedMemberId" color="primary" >
        <template v-for="(member, index) in space.service_practitioners" >
          <team-member-list-item
            v-model="space.service_practitioners[index]"
            v-if="showArchived || member.is_active"
            :key="member.id"
            :value="member.id"
            @selected="$router.push(`/settings/team/${space.id}/${member.id}`)" />
        </template>
      </v-list-item-group>
    </v-list>


    <v-card class="ma-2" outlined >
      <v-card-text >

        <v-btn block class="mb-3"
        to="/settings/team/new/"
        @click="selectedMemberId=null"
        color="primary" >Add teammate</v-btn>

        <v-btn block
          @click="launchNewSpaceWizard"
          color="primary" >Add space</v-btn>

      </v-card-text>
    </v-card>

  </template>

  <v-card class="ma-2 mt-3" outlined
    v-if="deactivatedSeats && deactivatedSeats.length > 0" >
    <v-card-title class="overline py-1 grey lighten-2" >
      Deactivated members
    </v-card-title>
    <v-card-text class="caption" >
      These are members who are no longer active on your account.
    </v-card-text>
    <v-list dense>
      <template v-for="seat in deactivatedSeats" >
        <v-list-item
          v-if="seat.practitioner && seat.practitioner.user"
          :key="seat.id" >
          <v-list-item-content>
            <v-list-item-title>
              {{seat.practitioner.user.first_name}} {{seat.practitioner.user.last_name}}
            </v-list-item-title>
            <v-list-item-subtitle >
              Deactivated: {{dateformat(seat.deactivation_date)}}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action >
            <v-btn small text
              @click="setReactivate(seat.practitioner)"
              color="error" >Reactivate</v-btn>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>

    <v-dialog v-model="reactivatedialog" >
      <v-card>
        <reactivate-account title="Reactivate account"
          v-if="selectedPractitioner"
          :business-id="businessId"
          :practitioner="selectedPractitioner"
          @close="reactivatedialog=false"
          @saved="accountReactivated(selectedPractitioner)" />
      </v-card>
    </v-dialog>
  </v-card>


  <!-- <template v-if="spaces && spaces.Member && spaces.Member.length > 0" >
    <v-list>
      <v-list-group >
        <template v-slot:activator>
          <v-list-item-title>Other spaces (you are a member)</v-list-item-title>
        </template>

        <template v-for="space in spaces.Member" >
          <v-subheader :key="space.id" class="overline" >{{space.title}}</v-subheader>
            <template v-for="(member, index) in space.service_practitioners" >
              <team-member-list-item
                v-model="space.service_practitioners[index]"
                :key="member.id" />
            </template>
        </template>
      </v-list-group>
    </v-list>
  </template> -->

</v-card>
</template>
<script>
import TeamMemberListItem from "@/components/listitems/TeamMemberListItem.vue"
import ReactivateAccount from "./actions/ReactivateAccount.vue"
export default {
  name: 'TeamSidebar',
  components:{ TeamMemberListItem, ReactivateAccount },
  props: {
    touch: { type: Number, default: 0 },
    businessId: { type: [Number, String], required: true }
  },
  data () {
    return {
      showArchived: false,
      reactivatedialog: false,
      selectedMemberId: null,
      selectedPractitioner: null,
      requests: {
        get: {
          // resource: 'ag.team'
          resource: 'ag.business'
        }
      }
    }
  },
  mounted () { this.get() },
  methods: {
    get () {
      this.requests.get.resourceId = this.businessId
      return this.$request('get', this.requests.get)
    },
    setReactivate (practitioner) {
      this.selectedPractitioner = practitioner
      this.reactivatedialog = true
    },
    accountReactivated (practitioner) {
      this.reactivatedialog = false
      this.get()
      this.$emit("saved", practitioner)
      console.log('reactivated')
    }
  },
  watch: {
    touch () {
      this.get()
    },
    globalLookupRequestStatus () {
      if (this.global.request.lookups.status === 200) {
        this.get()
      }
    }
  },
  computed: {
    // businesses () {
    //   return this.getObjectPath(this.requests.get, 'result.businesses', [])
    // },
    accountOwner () {
      return this.getObjectPath(this.requests.get, 'result.billable_practitioner', {})
    },
    accountOwnerUser () {
      return this.getObjectPath(this.accountOwner, 'user', {})
    },
    seats() {
      return this.getObjectPath(this.requests.get, 'result.seats', [])
    },
    activeSeats () {
      return this.seats.filter((seat) => {
        return seat.active !== false
      })
    },
    deactivatedSeats() {
      return this.seats.filter((seat) => {
        return seat.active === false
      })
    },
    spaces () {
      return this.getObjectPath(this.requests.get, 'result.spaces', {})
    },
    crumbs () {
      return [
        {text: 'Team', href: '/settings/team'},
        {text: 'New', href: '/settings/team/new'},
      ]
    }
  }
}
</script>
